export enum Direction {
  S = <any>"South",
  N = <any>"North",
  E = <any>"East",
  W = <any>"West",
  B = <any>"Both",
  Both = <any>"B"
}
